import type { RefObject } from 'react';
import { Box } from '@mui/material';
import type { ValidationWorkspaceState } from '../hooks/useValidationWorkspace';
import ValidationGroupRail from './ValidationGroupRail';

type ValidationTriageRailProps = {
  readonly containerRef: RefObject<HTMLDivElement | null>;
  readonly workspace: ValidationWorkspaceState;
  readonly activeFilters: readonly string[];
  readonly onClearFilters: () => void;
  readonly tourRefs: {
    readonly searchRef: RefObject<HTMLDivElement | null>;
    readonly filtersRef: RefObject<HTMLDivElement | null>;
    readonly repairAreaRef: RefObject<HTMLDivElement | null>;
    readonly passedRef: RefObject<HTMLDivElement | null>;
  };
};

export default function ValidationTriageRail({
  containerRef,
  workspace,
  activeFilters,
  onClearFilters,
  tourRefs,
}: ValidationTriageRailProps) {
  return (
    <Box ref={containerRef} data-testid="validation-tour-target-rail" sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <ValidationGroupRail
        searchQuery={workspace.searchQuery}
        onSearchChange={workspace.setSearchQuery}
        activeFilters={[...activeFilters]}
        onClearFilters={onClearFilters}
        severityFilter={workspace.severityFilter}
        onSelectSeverity={workspace.setSeverityFilter}
        blockerFilter={workspace.blockerFilter}
        onSelectBlockerFilter={workspace.setBlockerFilter}
        requiredOnly={workspace.requiredOnly}
        onToggleRequiredOnly={() => workspace.setRequiredOnly(!workspace.requiredOnly)}
        categoryFilter={workspace.categoryFilter}
        onSelectCategory={workspace.setCategoryFilter}
        severityCounts={workspace.severityCounts}
        categoryCounts={workspace.categoryCounts}
        blockerCount={workspace.blockerCount}
        requiredOnlyCount={workspace.requiredOnlyCount}
        showPassedOnly={workspace.showPassedOnly}
        onShowPassedOnly={workspace.setShowPassedOnly}
        passedCollapsed={workspace.passedCollapsed}
        onTogglePassedCollapsed={() => workspace.setPassedCollapsed(!workspace.passedCollapsed)}
        passedCount={workspace.passedChecks.length}
        tourRefs={tourRefs}
      />
    </Box>
  );
}
